export enum BlueskySubTypeEnum {
    POST = 'POST',
    QUOTE = 'QUOTE',
    REPLY = 'REPLY',
}
